var env = process.env.NODE_ENV;
var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var PostListHeader = require('./layout/postListHeader.jsx');
var PostListPartial = require('./layout/postListPartial.jsx');
var CategoryNav = require('./layout/categoryNav.jsx');
var Pagination = require('./layout/pagination.jsx');
var postUtils = require('../../../modules/posts/postUtils');

var PostList = createReactClass({

    fetchData: function(props) {
        var digestedParams = postUtils.digestParams(props.params);

        this.props.fetchPostListIfNeeded(digestedParams.categorySlug, digestedParams.pageNum);
    },

  	componentDidMount: function() {
        this.fetchData(this.props);
    },

    componentWillReceiveProps: function(nextProps) {
        if(nextProps.params.categorySlug !== this.props.params.categorySlug
            || nextProps.params.pageNum !== this.props.params.pageNum){

            this.fetchData(nextProps);
        }
    },

    hasDataLoaded: function(){
        return !!(this.props.postList.data.items && !this.props.postList.isFetching);
    },

	render: function () {
        var digestedParams = postUtils.digestParams(this.props.params);
        var totalPageNum = this.props.postList.data.items ? Math.ceil(this.props.postList.data.total/postUtils.config.pageSize) : 0;
        var shouldShowPagination = totalPageNum > 1 && (!digestedParams.pageNum || postUtils.isPageNumValid(digestedParams.pageNum));

        var children = [
            <div className="content-header-wrapper" key="content-header-wrapper">
                <div className="content-header-small content-header row column">
                    <h1>Blog</h1>
                </div>
            </div>,
            <div className="post-list-wrapper row" key="post-list-wrapper">
                <div className="column xlarge-10 xlarge-centered">
                    <CategoryNav categorySlug={digestedParams.categorySlug} categories={this.props.categories} />
                    <PostListHeader categorySlug={digestedParams.categorySlug} />
                    <PostListPartial
                        categorySlug={digestedParams.categorySlug}
                        pageNum={digestedParams.pageNum}
                        postContainers={this.props.postList.data.items}
                        setPost={this.props.setPost}
                        size="2" />
                    {shouldShowPagination &&
                        <div className="text-center">
                            <Pagination
                                baseUrl={'/blog/' + digestedParams.categorySlug + '/page'}
                                currentPageNum={postUtils.isPageNumValid(digestedParams.pageNum) ? parseInt(digestedParams.pageNum, 10) : 1}
                                totalPageNum={totalPageNum}
                                />
                        </div>
                    }
                </div>
            </div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return (
            <div className="content">
                <Helmet
                    title="Blog"
                    link={[
                        {
                            "rel": "canonical",
                            "href": env === "production" ? "https://mygi.health/blog/view-all"
                                : "https://staging.mygi.health/blog/view-all"
                        }
                    ]} />

                {content}
            </div>
        );
    }
});

module.exports = PostList;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/postList.jsx